module.exports = __webpack_public_path__ + "img/no-data-8coin.17bd2006.png";